import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\WikiCity\GetFavoriteWikiCityListController::__invoke
* @see app/Http/Controllers/WikiCity/GetFavoriteWikiCityListController.php
* @route '/api/city/favorite-cities'
*/
const GetFavoriteWikiCityListController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetFavoriteWikiCityListController.url(options),
    method: 'get',
})

GetFavoriteWikiCityListController.definition = {
    methods: ["get","head"],
    url: '/api/city/favorite-cities',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\WikiCity\GetFavoriteWikiCityListController::__invoke
* @see app/Http/Controllers/WikiCity/GetFavoriteWikiCityListController.php
* @route '/api/city/favorite-cities'
*/
GetFavoriteWikiCityListController.url = (options?: RouteQueryOptions) => {
    return GetFavoriteWikiCityListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\WikiCity\GetFavoriteWikiCityListController::__invoke
* @see app/Http/Controllers/WikiCity/GetFavoriteWikiCityListController.php
* @route '/api/city/favorite-cities'
*/
GetFavoriteWikiCityListController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetFavoriteWikiCityListController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\WikiCity\GetFavoriteWikiCityListController::__invoke
* @see app/Http/Controllers/WikiCity/GetFavoriteWikiCityListController.php
* @route '/api/city/favorite-cities'
*/
GetFavoriteWikiCityListController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetFavoriteWikiCityListController.url(options),
    method: 'head',
})

export default GetFavoriteWikiCityListController